var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 692 692",
    style: {
      enableBackground: "new 0 0 692 692"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#001829;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 346,
    cy: 346,
    r: 346
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M467.8,303c21.1,26.6,33.8,60.1,33.8,96.7s-13,71.1-34.7,97.8l-1.9,2.3l-0.5-2.9c-0.4-2.5-0.9-5-1.5-7.5 c-10.9-47.8-46.3-88.7-104.6-121.9c-39.4-22.3-61.9-49.2-67.8-79.8c-3.8-19.8-1-39.6,4.5-56.6c5.5-17,13.6-31.2,20.6-39.8 l22.7-27.7c4-4.9,11.4-4.9,15.4,0L467.8,303L467.8,303z M503.6,275.3l-152-185.8c-2.9-3.5-8.3-3.5-11.2,0l-152,185.8l-0.5,0.6 c-28,34.7-44.7,78.8-44.7,126.8c0,111.8,90.8,202.5,202.8,202.5c112,0,202.8-90.7,202.8-202.5c0-48-16.7-92.1-44.7-126.8 L503.6,275.3L503.6,275.3z M224.8,302.4l13.6-16.6l0.4,3.1c0.3,2.4,0.7,4.9,1.2,7.3c8.8,46.2,40.2,84.6,92.8,114.4 c45.7,26,72.3,55.9,79.9,88.6c3.2,13.7,3.8,27.1,2.4,38.9l-0.1,0.7l-0.7,0.3c-20.6,10.1-43.8,15.7-68.3,15.7 c-85.9,0-155.5-69.5-155.5-155.3C190.4,362.8,203.3,329,224.8,302.4L224.8,302.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuiIcon);
export default __webpack_public_path__ + "static/media/sui_icon.6189226235f5173af9a80ca93e76f6a7.svg";
export { ForwardRef as ReactComponent };